import React from 'react';
import { ApolloError } from '@apollo/client';
import { LinearProgress } from '@mui/material';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  LoadedContent,
  Pagination,
} from '@occc-app/design-system';
import { OpenCommerceUserFragment } from '@occc/graphql';
import { IPaginationProps } from '@occc-app/hooks/usePaginatedQuery';

import { UsersTableRow } from './UsersTableRow';

type UsersProps = {
  users: OpenCommerceUserFragment[] | undefined | null;
  loading: boolean;
  error?: ApolloError;
  paginationProps: IPaginationProps;
};

export const UsersTable: React.FC<UsersProps> = ({ users, loading, error, paginationProps }) => {
  const renderData = (items: OpenCommerceUserFragment[]) => {
    return (
      <>
        {loading && <LinearProgress />}
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Email Address</TableCell>
              <TableCell>Role</TableCell>
              <TableCell>Status</TableCell>
              <TableCell align='right'>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item) => (
              <UsersTableRow key={item.email} user={item} />
            ))}
          </TableBody>
        </Table>
        <Pagination {...paginationProps} />
      </>
    );
  };

  return (
    <LoadedContent<OpenCommerceUserFragment>
      error={error}
      loading={loading}
      items={users}
      renderData={renderData}
    />
  );
};
